import React, { useState } from 'react';
import { LayoutDashboard, MessageSquare, TrendingUp, Settings, Eye, MousePointer, Phone, Plus } from 'lucide-react';
import { DashboardLayout } from '../components/DashboardLayout';
import { Link, useNavigate } from 'react-router-dom';
import { PromoteListingModal } from '../components/modals/PromoteListingModal';
import { MessageModal } from '../components/modals/MessageModal';
export function SellerDashboardPage() {
  const navigate = useNavigate();
  const [isPromoteModalOpen, setIsPromoteModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [selectedListingId, setSelectedListingId] = useState<number | null>(null);
  const handleProceedToPay = () => {
    setIsPromoteModalOpen(false);
    setIsMessageModalOpen(true);
  };
  const handleEdit = (listingId: number) => {
    navigate(`/create-listing?edit=${listingId}`);
  };
  const handleViewInquiries = (listingId: number) => {
    navigate('/seller/inquiries');
  };
  const navItems = [{
    label: 'Overview',
    icon: LayoutDashboard,
    path: '/dashboard/seller'
  }, {
    label: 'Inquiries',
    icon: MessageSquare,
    path: '/seller/inquiries',
    badge: '12'
  }, {
    label: 'Performance',
    icon: TrendingUp,
    path: '/seller/performance'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/seller/settings'
  }];
  return <DashboardLayout title="Seller Console" personaLabel="SELLER" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="RK" data-id="element-5623">
      <div data-testid="seller-dashboard-page" className="space-y-8" data-id="element-5624">
        <div data-testid="seller-dashboard-header" className="flex justify-between items-center mb-8" data-id="element-5625">
          <div data-id="element-5626">
            <h1 data-testid="seller-dashboard-title" className="text-2xl font-bold mb-1" data-id="element-5627">
              My Listings
            </h1>
            <p data-testid="seller-dashboard-subtitle" className="text-gray-500 font-mono text-sm" data-id="element-5628">
              Managing 2 active plot listings.
            </p>
          </div>
          <Link data-testid="seller-dashboard-post-plot-btn" to="/create-listing" className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5629">
            <Plus className="w-4 h-4" data-id="element-5630" /> Post New Plot
          </Link>
        </div>

        <div data-testid="seller-dashboard-stats" className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-5631">
          <div data-testid="seller-dashboard-views-card" className="bg-white border border-gray-300 p-6" data-id="element-5632">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2 flex items-center gap-2" data-id="element-5633">
              <Eye className="w-4 h-4" data-id="element-5634" /> Total Views (30d)
            </h3>
            <div data-testid="seller-dashboard-views-count" className="text-3xl font-bold" data-id="element-5635">
              1,248
            </div>
            <div className="text-xs text-green-600 font-bold mt-1" data-id="element-5636">
              +12% vs last month
            </div>
          </div>

          <div data-testid="seller-dashboard-click-rate-card" className="bg-white border border-gray-300 p-6" data-id="element-5637">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2 flex items-center gap-2" data-id="element-5638">
              <MousePointer className="w-4 h-4" data-id="element-5639" /> Click Rate
            </h3>
            <div data-testid="seller-dashboard-click-rate" className="text-3xl font-bold" data-id="element-5640">
              4.8%
            </div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-5641">
              Avg. industry: 3.2%
            </div>
          </div>

          <div data-testid="seller-dashboard-leads-card" className="bg-white border border-gray-300 p-6" data-id="element-5642">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2 flex items-center gap-2" data-id="element-5643">
              <Phone className="w-4 h-4" data-id="element-5644" /> Leads Generated
            </h3>
            <div data-testid="seller-dashboard-leads-count" className="text-3xl font-bold" data-id="element-5645">
              18
            </div>
            <div className="text-xs text-green-600 font-bold mt-1" data-id="element-5646">
              3 new today
            </div>
          </div>
        </div>

        <div data-testid="seller-dashboard-listings-table" className="bg-white border border-gray-300 mb-8" data-id="element-5647">
          <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-5648">
            <h2 className="font-bold text-lg" data-id="element-5649">Active Listings</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-5650">
            <table className="w-full text-left text-sm" data-id="element-5651">
              <thead className="bg-gray-50 border-b border-gray-200 font-mono text-xs uppercase text-gray-500" data-id="element-5652">
                <tr data-id="element-5653">
                  <th className="p-4 font-bold" data-id="element-5654">Property</th>
                  <th className="p-4 font-bold" data-id="element-5655">Price</th>
                  <th className="p-4 font-bold" data-id="element-5656">Status</th>
                  <th className="p-4 font-bold" data-id="element-5657">Views</th>
                  <th className="p-4 font-bold" data-id="element-5658">Inquiries</th>
                  <th className="p-4 font-bold text-right" data-id="element-5659">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-5660">
                {[{
                id: 1,
                title: 'Corner Plot in Hinjewadi',
                price: '₹45 L',
                status: 'Active',
                views: 842,
                inquiries: 12
              }, {
                id: 2,
                title: 'Agri Land in Mulshi',
                price: '₹22 L',
                status: 'Pending',
                views: 406,
                inquiries: 6
              }].map((item, i) => <tr key={i} data-testid={`seller-dashboard-listing-row-${i + 1}`} className="hover:bg-gray-50" data-id="element-5661">
                    <td className="p-4 font-bold" data-id="element-5662">
                      <Link to={`/listing/${item.id}`} className="hover:underline hover:text-blue-600" data-id="element-5663">
                        {item.title}
                      </Link>
                    </td>
                    <td className="p-4 font-mono" data-id="element-5664">{item.price}</td>
                    <td className="p-4" data-id="element-5665">
                      <span data-testid={`seller-dashboard-listing-row-${i + 1}-status`} className={`inline-block px-2 py-0.5 text-xs font-bold rounded-sm border ${item.status === 'Active' ? 'bg-green-100 text-green-800 border-green-200' : 'bg-yellow-100 text-yellow-800 border-yellow-200'}`} data-id="element-5666">
                        {item.status.toUpperCase()}
                      </span>
                    </td>
                    <td className="p-4" data-id="element-5667">{item.views}</td>
                    <td className="p-4" data-id="element-5668">
                      <button data-testid={`seller-dashboard-listing-row-${i + 1}-inquiries-btn`} onClick={() => handleViewInquiries(item.id)} className="font-bold text-blue-600 hover:underline" data-id="element-5669">
                        {item.inquiries}
                      </button>
                    </td>
                    <td className="p-4 text-right" data-id="element-5670">
                      <div className="flex justify-end gap-2" data-id="element-5671">
                        <button data-testid={`seller-dashboard-listing-row-${i + 1}-edit-btn`} onClick={() => handleEdit(item.id)} className="text-xs font-bold border border-gray-300 px-2 py-1 hover:bg-gray-50" data-id="element-5672">
                          Edit
                        </button>
                        <button data-testid={`seller-dashboard-listing-row-${i + 1}-promote-btn`} onClick={() => {
                      setSelectedListingId(item.id);
                      setIsPromoteModalOpen(true);
                    }} className="text-xs font-bold bg-blue-50 text-blue-700 border border-blue-200 px-2 py-1 hover:bg-blue-100" data-id="element-5673">
                          Promote
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <PromoteListingModal isOpen={isPromoteModalOpen} onClose={() => setIsPromoteModalOpen(false)} onProceedToPay={handleProceedToPay} data-id="element-5674" />

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Payment Processing" message="Redirecting to payment gateway... In production, this would integrate with Razorpay or Stripe for secure payment processing." type="info" data-id="element-5675" />
    </DashboardLayout>;
}